import { DataGridPagination, QueryParams } from "@/sharedTypes";
import { SetStateAction } from "react";

export function createPaginationHandler(
  setState: React.Dispatch<SetStateAction<QueryParams>>,
) {
  return (newPageIndex: number) => {
    setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: newPageIndex, // Update only the page index
      },
    }));
  };
}
